import React, { useEffect, useState } from "react";
import { injectIntl } from 'react-intl';
import { CSSTransition } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faSearch } from '@fortawesome/free-solid-svg-icons';
import * as aTypes from 'Flow2/components/AdvancedBox/AdvancedConfig/AdvancedTypes';
import './HelpForm.scss';

function HelpForm(props) {
    const [current, setCurrent] = useState({});
    const [data, setData] = useState(props.data);
    const [isOpen, setIsOpen] = useState(false);
    const [ddInput, setDDInput] = useState('');

    const fm = ({ id }) => props.intl.formatMessage({ id });

    const setInitData = () => {
        setDDInput('');
        setIsOpen(false);
        setData(props.data);
    }

    const onDDItemClick = (item) => {
        props.onDDClick(item);
        setTimeout(() => {
            setCurrent(item);
            setInitData();
        }, 10);
    }

    const onDDItemTrashClick = (item) => {
        props.onDDTrashClick(item);
    }

    const handleInputChange = (e) => {
        const { value } = e.target;
        setDDInput(value);
        if (value) {
            let newData = props.data.filter(item => item.intl.toLowerCase().includes(value));
            setData(newData);
            if (newData && newData.length) setIsOpen(true);
            else setIsOpen(false);
        } else {
            setData([]);
            setIsOpen(false);
            props.setInit();
        }
    }

    const handleOutside = ({ target }) => {
        if (!target.closest('.dropdowninput-box')) {
            setInitData();
        }
    }

    useEffect(() => {
        window.addEventListener('click', handleOutside);
        return () => {
            window.removeEventListener('click', handleOutside)
        }
    }, []);

    useEffect(() => {
        if (props.data && props.data.length > 0) {
            //setData(props.data);
            if (props.current) {
                if (typeof props.current == 'string') {
                    let found = props.data.find(item => item.value === props.current
                        || item.name === props.current);
                    if (found) setCurrent(found);
                } else {
                    setCurrent(props.current);
                }
            }
            else setCurrent(props.data[0]);
        }
    }, [props.data, props.current])

    return (
        <div className="helpform">
            <input type="text" className="dropdown-top-input" value={ddInput}
                // onBlur={() => setIsOpen(false)} onFocus={() => setIsOpen(true)}
                onChange={handleInputChange} />
            <div className={isOpen ? "dropdown active" : "dropdown"}>
                <div className="dropdown-top">
                    <div>{(current && current.name) ? current.name : current.value}</div>
                    <FontAwesomeIcon icon={faSearch} />
                </div>
                <CSSTransition in={isOpen} timeout={300} classNames="dropdown-animation"
                    unmountOnExit onEnter={() => setIsOpen(true)} onExited={() => setIsOpen(false)}>
                    <div className="dropdown-box">
                        <ul>
                            {data && data.map((item, i) => (
                                <li className="dropdown-li" key={`dropdownMenuItem${i}`}>
                                    <a className="data-link" onClick={onDDItemClick.bind(null, item)}>
                                        {item.intl ? fm({ id: item.intl }) : item.value}
                                    </a>
                                    {(props.isDeleted && item.value !== aTypes.DUMMY_X) && (
                                        <span onClick={onDDItemTrashClick.bind(null, item)}
                                            className="dropdown-icon">
                                            <FontAwesomeIcon icon={faTrash} />
                                        </span>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>
                </CSSTransition>
            </div>
        </div>
    )
}

export default injectIntl(HelpForm);